import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { HTMLElement, h, Host, proxyCustomElement } from '@stencil/core/internal/client';

var navLink = function navLink(el, routerDirection, component, componentProps, routerAnimation) {
  var nav = el.closest('ion-nav');

  if (nav) {
    if (routerDirection === 'forward') {
      if (component !== undefined) {
        return nav.push(component, componentProps, {
          skipIfBusy: true,
          animationBuilder: routerAnimation
        });
      }
    } else if (routerDirection === 'root') {
      if (component !== undefined) {
        return nav.setRoot(component, componentProps, {
          skipIfBusy: true,
          animationBuilder: routerAnimation
        });
      }
    } else if (routerDirection === 'back') {
      return nav.pop({
        skipIfBusy: true,
        animationBuilder: routerAnimation
      });
    }
  }

  return Promise.resolve(false);
};

var NavLink = /*#__PURE__*/function (_HTMLElement) {
  _inherits(NavLink, _HTMLElement);

  var _super = _createSuper(NavLink);

  function NavLink() {
    var _this;

    _classCallCheck(this, NavLink);

    _this = _super.call(this);

    _this.__registerHost();
    /**
     * The transition direction when navigating to another page.
     */


    _this.routerDirection = 'forward';

    _this.onClick = function () {
      return navLink(_this.el, _this.routerDirection, _this.component, _this.componentProps, _this.routerAnimation);
    };

    return _this;
  }

  _createClass(NavLink, [{
    key: "render",
    value: function render() {
      return h(Host, {
        onClick: this.onClick
      });
    }
  }, {
    key: "el",
    get: function get() {
      return this;
    }
  }]);

  return NavLink;
}(HTMLElement);

NavLink = /*@__PURE__*/proxyCustomElement(NavLink, [0, "ion-nav-link", {
  "component": [1],
  "componentProps": [16],
  "routerDirection": [1, "router-direction"],
  "routerAnimation": [16]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["ion-nav-link"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "ion-nav-link":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, NavLink);
        }

        break;
    }
  });
}

var IonNavLink = NavLink;
var defineCustomElement = defineCustomElement$1;
export { IonNavLink, defineCustomElement };